import { render, staticRenderFns } from "./ACategoriaMoodleModulo.vue?vue&type=template&id=615f77e8"
import script from "./ACategoriaMoodleModulo.vue?vue&type=script&lang=js"
export * from "./ACategoriaMoodleModulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports